const rolesDescriptions = {
  admin: 'Unrestricted access to the account, its data, and its settings.',
  member: 'Members can only view and act on the data account.',
};

const membersRoles = {
  admin: 'Administrator',
  member: 'Member',
  superGuuru: 'Super Guuru',
};

const allRoles = {
  financeManager: 'Finance Manager',
  communityManager: 'Community Manager',
  productManager: 'Product Manager',
  engineer: 'Engineer',
  salesGlobalAll: 'Global Sales',
  superAdmin: 'Super Admin',
};

const baseRoles = {
  guuru: 'Guuru',
  agent: 'Agent',
  token: 'token',
  anonymous: 'anonymous',
};

const possibleRoles = {
  ...baseRoles,
  ...membersRoles,
  ...allRoles,
};

export {
  membersRoles,
  possibleRoles,
  allRoles,
  baseRoles,
  rolesDescriptions,
};
